import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import FileUploader from "../../../../TCPForms/forms/registration/FileUploader";
import ButtonWrapper from "../../../components/Button";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";

const Step5 = ({ formData, handleTabChange, handleSubTabChange, tradeType, isReapply, initRegistrationDocs }) => {
  const { t } = useTranslation();
  const { applicationDocuments } = useSelector((state) => state.registration);
  const [showError, setShowError] = useState(false);
  const watchRegistrationType = formData?.registrationType;
  console.log(formData, "formDatainStep5");
  
  console.log("applicationDocumentsFromTL", applicationDocuments);
  const validateFiles = () => {
    const uploadedDocs = new Set(applicationDocuments?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs = ["applicantPhoto", "Id Proof", "Registration Certificate", "Qualification Certificate"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const handleFormSubmit = (data) => {
    const isValid = validateFiles();
    console.log("insideFormSUbmit", data, isValid);
    if (isValid) {
      console.log("submitIf", isValid, data);
      onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, control, setValue } = useForm({ defaultValues });

  useEffect(() => {
    if (!formData?.tradeLicenseDetail?.applicationDocuments) {
      setValue("tradeLicenseDetail.applicationDocuments", applicationDocuments);
    }
    // if(isReapply){
    //   setValue("tradeLicenseDetail.applicationDocuments", formData?.tradeLicenseDetail?.applicationDocuments);
    // }
  }, [applicationDocuments]);

  useEffect(() => {
      if (formData?.tradeLicenseDetail?.applicationDocuments?.length > 0) {
        initRegistrationDocs(formData?.tradeLicenseDetail?.applicationDocuments);
      }
    }, [formData?.tradeLicenseDetail?.applicationDocuments]);
  
    useEffect(() => {
      if (applicationDocuments?.length >= 0) {
        setValue("tradeLicenseDetail.applicationDocuments", applicationDocuments);
      }
    }, [applicationDocuments, setValue]);

  // useEffect(() => {
  //   setValue("tradeLicenseDetail.applicationDocuments", applicationDocuments);
  // }, [applicationDocuments]);
  const onSubmit = (data) => {
    handleSubTabChange(5, data);
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("LABEL_DOCUMENT_DETAILS")}</h2>
          </div>

          <Container className="formInputContainer common-app-form self-certified custom-upload new-custom-uploader" fluid>
            <Row>
              <Col>
                <FileUploader
                  label={t("LABEL_PHOTO")}
                  control={control}
                  name="applicantPhoto"
                  validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                  required
                  isMandatory={true}
                  showError={showError}
                  tab={1}
                  existingDocs={formData?.tradeLicenseDetail?.applicationDocuments}
                  //disabled={isReapply}
                />
              </Col>

              <Col>
                <FileUploader
                  label={"ID Proof Attachment"}
                  control={control}
                  name="Id Proof"
                  isMandatory={true}
                  showError={showError}
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                  existingDocs={formData?.tradeLicenseDetail?.applicationDocuments}
                  //disabled={isReapply}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <FileUploader
                  label="COA/IEI Registration Certificate"
                  control={control}
                  name="Registration Certificate"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  isMandatory={watchRegistrationType !== "Supervisor"}
                  showError={showError}
                  required
                  existingDocs={formData?.tradeLicenseDetail?.applicationDocuments}
                   // dynamic mandatory
                />
              </Col>
              <Col>
                <FileUploader
                  label={t("LABEL_EXPERIENCE_CERTIFICATE")}
                  control={control}
                  name="Experience Certificate"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  existingDocs={formData?.tradeLicenseDetail?.applicationDocuments}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <FileUploader
                  isMandatory={true}
                  label={t("LABEL_QUALIFICATION_CERTIFICATE")}
                  showError={showError}
                  control={control}
                  name="Qualification Certificate"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                  existingDocs={formData?.tradeLicenseDetail?.applicationDocuments}
                  //disabled={isReapply}
                />
              </Col>
              <Col></Col>
            </Row>

            {/* <FileUploader
                                isMandatory
                                control={control}
                                name="signature"
                                label={t("LABEL_SIGNATURE")}
                                validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                required
                                tab={1}
                            /> */}
          </Container>
        </div>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleSubTabChange(3)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step5;
